const dialogStore = {
  namespaced: 'DIALOG',
  state: {
    dialog_stack: [],
    dialog_param: {}, // 모달에 전달하는 파라미터(신청쪽이랑 연결되어있음..)
    dialog_param2: {}, // 모달에 전달하는 파라미터
    dialog_callback: false, // 모달종료후 콜백여부

    search_executives_multi: false, // 임직원선택 다건
    search_executives: false, // 결재선_임직원검색
    change_approval_line: false, // 결재선_결재선변경
    add_referrer: false, // 결재선_참조자추가
    select_work_term: false, // 근무현황_근무기간선택
    calendar_detail: false, // 일정_일정상세
    application_viewer: false, // 신청서 뷰어
    member_profile: false, // 직원찾기_직원프로필
    board_detail: false, // 공지사항_공지사항상세
    pay_detail: false, // 급여명세서_상세
    pay_calc_detail: false, // 급여명세서_계산방법_상세
    application_confirm: false, // 신청완료뷰어
    reject_reason: false, // 반려사유
    select_annual_plan_date: false, // 연차계획작성 날짜선택
    find_password: false, // 로그인_비밀번호찾기
    reset_password_single: false, // 로그인_비밀번호재설정_단건
    reset_password_multi: false, // 로그인_비밀번호재설정_다건
    add_mgrrer: false, // 결재선_담당자추가
    add_work_log: false, // 업무일지추가
    work_log_detail: false, // 업무일지 상세
    view_auth_org_list: false, // 조회권한 부서목록
    work_log_not_registered_list: false, // 업무일지 미작성목록
    work_log_not_viewed_list: false, // 업무일지 미열람목록
    certificate_rd: false, // 제증명서 RD
  },
  getters: {
    GET_DIALOG_STACK(state) {
      return state.dialog_stack;
    },
    GET_DIALOG_STACK_SIZE(state) {
      return state.dialog_stack.length;
    },
    GET_DIALOG_PARAM(state) {
      return state.dialog_param;
    },
    GET_DIALOG_PARAM2(state) {
      return state.dialog_param2;
    },
    GET_DIALOG_CALLBACK(state) {
      return state.dialog_callback;
    },
  },
  mutations: {
    TOGGLE_MODAL(state, modalName) {
      // 다이얼로그 스택 쌓기
      const stackIndex = state.dialog_stack.indexOf(modalName);
      if (stackIndex !== -1) {
        state.dialog_stack.splice(stackIndex, 1);
      } else {
        state.dialog_stack.push(modalName);
      }

      // 다이얼로그 토글
      switch (modalName) {
        case 'search_executives':
          state.search_executives = !state.search_executives;
          break;
        case 'search_executives_multi':
          state.search_executives_multi = !state.search_executives_multi;
          break;
        case 'change_approval_line':
          state.change_approval_line = !state.change_approval_line;
          break;
        case 'add_referrer':
          state.add_referrer = !state.add_referrer;
          break;
        case 'select_work_term':
          state.select_work_term = !state.select_work_term;
          break;
        case 'calendar_detail':
          state.calendar_detail = !state.calendar_detail;
          break;
        case 'application_viewer':
          state.application_viewer = !state.application_viewer;
          break;
        case 'member_profile':
          state.member_profile = !state.member_profile;
          break;
        case 'board_detail':
          state.board_detail = !state.board_detail;
          break;
        case 'pay_detail':
          state.pay_detail = !state.pay_detail;
          break;
        case 'pay_calc_detail':
          state.pay_calc_detail = !state.pay_calc_detail;
          break;
        case 'application_confirm':
          state.application_confirm = !state.application_confirm;
          break;
        case 'reject_reason':
          state.reject_reason = !state.reject_reason;
          break;
        case 'select_annual_plan_date':
          state.select_annual_plan_date = !state.select_annual_plan_date;
          break;
        case 'find_password':
          state.find_password = !state.find_password;
          break;
        case 'reset_password_single':
          state.reset_password_single = !state.reset_password_single;
          break;
        case 'reset_password_multi':
          state.reset_password_multi = !state.reset_password_multi;
          break;
        case 'add_mgrrer': // 담당자팝업추가
          state.add_mgrrer = !state.add_mgrrer;
          break;
        case 'add_work_log': // 업무일지 추가
          state.add_work_log = !state.add_work_log;
          break;
        case 'work_log_detail': // 업무일지 상세
          state.work_log_detail = !state.work_log_detail;
          break;
        case 'view_auth_org_list': // 조회권한 부서목록
          state.view_auth_org_list = !state.view_auth_org_list;
          break;
        case 'work_log_not_registered_list': // 업무일지 미작성목록
          state.work_log_not_registered_list =
            !state.work_log_not_registered_list;
          break;
        case 'work_log_not_viewed_list': // 업무일지 미열람목록
          state.work_log_not_viewed_list = !state.work_log_not_viewed_list;
          break;
        case 'certificate_rd': // 제증명서 RD
          state.certificate_rd = !state.certificate_rd;
          break;
      }
    },
    SET_DIALOG_PARAM(state, data) {
      state.dialog_param = data;
    },
    SET_DIALOG_PARAM2(state, data) {
      state.dialog_param2 = data;
    },
    SET_DIALOG_CALLBACK(state, data) {
      state.dialog_callback = data;
    },

    SET_EMPTY_DIALOG_STACK(state) {
      state.dialog_stack = [];
    },
  },
};

export default dialogStore;
